import styled from 'styled-components';

export const StyledClients = styled.section`
  background-color: var(--light-bg);
  padding: 100px 0;

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  h2 {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 50px;
    color: var(--text-color);
    font-family:gunar thin, sans-serif;
    font-weight: bold; 
    letter-spacing: 2px;

    .highlight {
      color: var(--primary-color);
    }
  }
`;

export const ClientsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  align-items: center;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const ClientLogo = styled.div`
  background-color: ${props => props.bgColor || '#ccc'};
  border-radius: 8px;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--box-shadow);
  transition: all 0.3s ease;
  height: 150px;

  img {
    max-width: 100%;
    max-height: 80px;
    /* opacity: 0.7; */
    transition: all 0.3s ease;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);

    img {
      filter: grayscale(0);
    }
  }
`;
